import React from 'react';
import Map from './Map';
import useMap from './useMap';
function FlightLogMap({ apiKey, path }) {
    const { loaded, setBounds } = useMap();
    React.useEffect(() => {
        if (!loaded || !path?.length) {
            return;
        }
        setBounds?.(path.map((e) => ({ lat: e.lat, lng: e.lng })));
    }, [path, setBounds, loaded]);
    return React.createElement(Map, { apiKey: apiKey, paths: path.length ? [path] : undefined, locked: true, hideAllUIs: true, draggable: true, highlightPath: true });
}
export default React.memo(FlightLogMap);
